export const QUERY_KEYS = {
  lat: 'lat',
  lng: 'lng',
  city: 'city',
  userQuery: 'q',
  isApp: 'isApp',
};

export const LIST_SEARCH_DISTANCE_IN_KM = 25;

export const LOCATION_TYPES = {
  SUPERCHARGER: 'supercharger',
  DESTINATION_CHARGER: 'destination charger',
};

export const DISTANCE_UNIT = {
  KM: 'km',
  METRE: 'm',
};

export const CHARGER_TYPES = {
  TSLA_SUPERCHARGER: 'TSLA_SUPERCHARGER',
  TSLA_DESTINATION_CHARGER: 'TSLA_DESTINATION_CHARGER',
  OTHER_CHARGER: 'OTHER_CHARGER',
};

export const IMAGE_DOMAIN = 'https://digitalassets.tesla.com/oxp/image/upload';
export const CHARGER_ICON = `${IMAGE_DOMAIN}/f_auto,q_auto/wall_connector_f0d529a91728d.png`;
export const BACK_TO_CURRENT_ICON = `${IMAGE_DOMAIN}/v1763629102/back_to_current_72449005f5388.png`;
export const LIST_ICON = `${IMAGE_DOMAIN}/v1763629109/list_58d66f1d1015b.png`;
export const CURRENT_POSITION_ICON = `${IMAGE_DOMAIN}/f_auto,q_auto/current_pin_3x_c6b7a62ccec54.png`;
export const SUPER_CHARGER_ICON = `${IMAGE_DOMAIN}/f_auto,q_auto/sc_default_64db196eb5662.png`;
export const SUPER_CHARGER_ACTIVE_ICON = `${IMAGE_DOMAIN}/f_auto,q_auto/sc_active_65bc7e08bd86a.png`;
export const SUPER_CHARGER_NON_TESLA_ICON = `${IMAGE_DOMAIN}/v1764844392/sc_open_default_b88dae4c2ea39.png`;
export const SUPER_CHARGER_NON_TESLA_ACTIVE_ICON = `${IMAGE_DOMAIN}/v1764844392/sc_open_active_5d5f5d369c4dd.png`;
export const DESTINATION_CHARGER_ICON = `${IMAGE_DOMAIN}/f_auto,q_auto/dc_default_4994a2af4231a.png`;
export const DESTINATION_CHARGER_ACTIVE_ICON = `${IMAGE_DOMAIN}/f_auto,q_auto/dc_active_25e8cbae4ee61.png`;
export const DESTINATION_CHARGER_NON_TESLA_ICON = `${IMAGE_DOMAIN}/v1764844392/dc_open_default_cffe8074276da.png`;
export const DESTINATION_CHARGER_NON_TESLA_ACTIVE_ICON = `${IMAGE_DOMAIN}/v1764844393/dc_open_active_74d58059933f5.png`;
export const OTHER_CHARGER_ICON = `${IMAGE_DOMAIN}/f_auto,q_auto/third_active_dc071a5297915.png`;
export const OTHER_CHARGER_ACTIVE_ICON = `${IMAGE_DOMAIN}/f_auto,q_auto/third_default_7b5c976267321.png`;

export const MAP_MODE = {
  MAP: 'map',
  LIST: 'list',
};
export const BMAP_MIN_ZOOM = 5;
export const BMAP_DEFAULT_ZOOM = 13;
// default Shang Hai
export const BMAP_DEFAULT_CENTER = {
  lng: 121.50109,
  lat: 31.23691,
};
